"use strict";
/* eslint-disable import/extensions */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var OverflowTooltipText = function (_a) {
    var text = _a.text, _b = _a.variant, variant = _b === void 0 ? 'h4.semi-bold' : _b, _c = _a.color, color = _c === void 0 ? 'black.haptik' : _c, className = _a.className, style = _a.style, _d = _a.tooltipPosition, tooltipPosition = _d === void 0 ? 'TOP' : _d;
    var containerRef = react_1["default"].useRef(null);
    var _e = react_1["default"].useState(false), isOverflowing = _e[0], setIsOverflowing = _e[1];
    react_1["default"].useLayoutEffect(function () {
        var element = containerRef.current;
        if (!element)
            return;
        var measureOverflow = function () {
            setIsOverflowing(element.scrollWidth > element.clientWidth);
        };
        var rafId = window.requestAnimationFrame(measureOverflow);
        window.addEventListener('resize', measureOverflow);
        return function () {
            window.cancelAnimationFrame(rafId);
            window.removeEventListener('resize', measureOverflow);
        };
    }, [text]);
    var content = (react_1["default"].createElement("div", { ref: containerRef, className: className, style: __assign({ width: '100%', maxWidth: '100%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, style) },
        react_1["default"].createElement(text_1["default"], { variant: variant, color: color, style: { display: 'inline' } }, text)));
    if (!isOverflowing || !text) {
        return content;
    }
    return (react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: text, position: tooltipPosition }, content));
};
exports["default"] = OverflowTooltipText;
